
    import Vue from 'vue'
    import {Component, Watch} from "vue-property-decorator";
    import LoadingScreen from "./LoadingScreen.vue";
    import SlideshowView from "./SlideshowView.vue";
    import {VueInject} from "@/VueIntegration/VueInjectable";
    import {settings, SettingsEvents, SettingsService} from "@/Core/Settings";
    import {PubSub} from "@/Core/PubSub";
    
    @Component({
        components: {
            LoadingScreen,
            SlideshowView
        }
    })
    export default class App extends Vue {
        @VueInject("SettingsService") settingsService: SettingsService;
        @VueInject("PubSub") pubSub: PubSub;

        isLoading: boolean = true;
        isCreatorModeEnabled = false;
        canUseCreatorMode = false;
        focusColorClass = settings.focusOutline + '-focus';

        created() {
            this.pubSub.subscribeToEvent(SettingsEvents.focusOutline, color => {
                this.focusColorClass = color + '-focus';
            });
        }

        @Watch('isLoading')
        onLoad() {
            if (this.isLoading)
                return;

            let isCreatorMode = false; //this.attempt.isCreatorMode;
            this.canUseCreatorMode = isCreatorMode;
            this.isCreatorModeEnabled = isCreatorMode;

            if (isCreatorMode) {
                document.addEventListener('keydown', e => {
                    if ((e.ctrlKey || e.metaKey) && (e.key === '#' || e.key === '\\')) {
                        this.isCreatorModeEnabled = !this.isCreatorModeEnabled;
                    }
                });
            }
        }
    }

